import {
  ExternalConnection,
  ExternalConnectionsCapabilities,
} from '@griply/types';

export const canConnectionReadContacts = (
  connection: ExternalConnection,
): boolean =>
  !!connection.capabilities?.includes(
    ExternalConnectionsCapabilities.ReadContacts,
  );
